import { Button } from '@/components/ui/button';
import { cn } from '@/lib/tailwind-utils';
import { NAV } from '@airreading/automation-test/test-ids';
import { Link } from '@tanstack/react-router';
import { Menu } from 'lucide-react';

interface MobileHeaderProps {
  userIsStudent: boolean;
  onOpen: () => void;
}

export const MobileHeader = ({ userIsStudent, onOpen }: MobileHeaderProps) => {
  return (
    <header
      className={cn('md:hidden flex items-center justify-between px-4 h-14 border-b border-border bg-white', {
        'bg-[#eb404a] border-[#d23841]': userIsStudent,
      })}
    >
      <Link to="/" className="flex items-center" data-testid={NAV.logo}>
        {userIsStudent ? (
          <img src="/white-logo.svg" alt="Air Reading Logo" className="h-8" />
        ) : (
          <img src="/logo.svg" alt="Air Reading Logo" className="h-8" />
        )}
      </Link>
      <Button
        variant={'ghost'}
        onClick={onOpen}
        aria-label="Open menu"
        data-testid={NAV.mobileMenuButton}
        className={cn('rounded p-2 text-foreground transition-colors hover:bg-accent', {
          'text-white hover:bg-[#d23841] hover:text-white': userIsStudent,
        })}
      >
        <Menu className="h-6 w-6" />
      </Button>
    </header>
  );
};
